import 'lazysizes';
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'

/*
*
* Shopify Media - Product Media 
*
* @link https://photoswipe.com/documentation/getting-started.html
* @link https://shopify.dev/docs/themes/liquid/reference/objects/media
* 
*/
theme.media = {

    pswp: '',
    pswpMedia: [],
    pswpOptions: {},
    pswpElement: '',
    pswpClass: PhotoSwipeUI_Default,

    init: function() {

        // Loop through elements and determine what to do with them
        let $media = $('[data-product-image]')
        $.each($media, function() {

            // What type is it?
            // @link https://shopify.dev/docs/themes/liquid/reference/objects/media
            let type = $(this).data('media-type')

            switch (type) {
                // Push an image onto the stack.
                case 'image':
                    theme.media.pswpMedia.push({
                        src: $(this).data('img-full'),
                        w: $(this).data('img-width'),
                        h: $(this).data('img-height')
                    })
                    break;
                // Push the media tag onto the stack.
                case 'video':
                    // Embedded video
                    let video_html = $(this).find('[data-media-html]').html()
                    if (video_html) {
                        theme.media.pswpMedia.push({
                            html: video_html,
                        })
                    }                    
                    break;
                // Push the <iframe> onto the stack.
                case 'external_video':
                    let external_video_html = $(this).find('[data-media-html]').html()
                    if (external_video_html) {
                        theme.media.pswpMedia.push({
                            html: external_video_html,
                        })
                    }
                    break;      
                // 3D Model, Integrate into PSWP if required
                case 'model':
                    break;
                default:
                    break;
            }

        })

        this.events()

        $('[data-additional-image-container]').removeClass('invisible opacity-0')

    },

    // Setup the product carousel if required
    carousel: function() {},

    // Setup the product events
    events: function() {

        // Setup gallery
        this.pswpElement = document.querySelectorAll('.pswp')[0]

        theme.media.pswpOptions = {
            index: 0,
            captionEl: false,
            tapToClose: false,
            shareEl: false,
            fullscreenEl: false,
            counterEl: false,
            tapToToggleControls: false,
        }

        // When the main image is clicked, open a gallery
        $('[data-product-image]').on('click', function(e) {

            // Stop default.
            e.preventDefault()

            // Media index
            theme.media.pswpOptions.index = $(this).data('img-index')

            // Constructor
            theme.media.pswp = new PhotoSwipe(
                theme.media.pswpElement, 
                theme.media.pswpClass, 
                theme.media.pswpMedia, 
                theme.media.pswpOptions,
            )
            
            // Init.
            theme.media.pswp.init()
            
            // Listen.
            theme.media.pswp.listen('close', function() {
                theme.media.reset()
            });

            // Manually close
            $('[data-pswp-close]').on('click', function(e){
                e.preventDefault()
                theme.media.pswp.close()
            })
            
            // Manually prev
            $('[data-pswp-prev]').on('click', function(e){
                e.preventDefault()
                theme.media.pswp.prev()
            })

            // Manually next
            $('[data-pswp-next]').on('click', function(e){
                e.preventDefault()
                theme.media.pswp.next()
            })

        })

    },

    // Reset all videos by pausing them
    reset: function() {
        let videos = document.querySelectorAll('video');
        videos.forEach(function(video) {
            // Pause.
            video.pause()
        })
    }

}

// Boot the media
$(function(){
    theme.media.init()
})